<template>
  <div id="doc-selecao">
    <h1 class="titulo">Agora, é só tirar a foto de <br> um documento</h1>
    <p class="subtitulo">Qual você prefere usar?</p>
    <div class="documentos">
      <ul class="list-group">
        <li class="list-group-item d-flex justify-content-between align-items-center" v-on:click="nextPage(docs.rg)">
          <div>
            <p class="txt-subtitulo">RG</p>
          </div>
          <i class="bi bi-chevron-right"></i>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center" v-on:click="nextPage(docs.cnh)">
          <div>
            <p class="txt-subtitulo">CNH</p>
          </div>
          <i class="bi bi-chevron-right"></i>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center" v-on:click="nextPage(docs.cnhdigital)">
          <div>
            <p class="txt-subtitulo">CNH digital</p>
            <p class="txt-padrao">Documento oficial baixado no app do governo</p>
          </div>
          <i class="bi bi-chevron-right"></i>
        </li>
        <li class="list-group-item d-flex justify-content-between align-items-center" v-on:click="nextPage(docs.outro)">
          <div>
            <p class="txt-subtitulo">Outro documento com foto e CPF</p>
          </div>
          <i class="bi bi-chevron-right"></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AppService from "../../services/AppService";
import DispatchTags from "../../utils/DispatchTags";

export default {
  name: "DocSelecao",
  mounted() {
    if(this.$store.getters.tipoCaptura !== 1 && this.$store.getters.indApiN1 !== 1){
      this.$router.push({name:'Analise'});
      return;
    }
    this.$store.dispatch('setTitulo','Confirmar identidade');
    this.$store.dispatch('setLoadingStatus',false);
    this.$store.dispatch('setTipoDoc',null);
    sessionStorage.removeItem('A');
    sessionStorage.removeItem('B');
    DispatchTags.dispatchScreenView('DocSelecao');
    this.appService = new AppService();
    this.appService.preLoadDocumento();
  },
  data:function (){
    return {};
  },
  computed:{
    docs: function (){
      return  this.appService.tipoDOC()
    }
  },
  methods:{
    nextPage: function (tipoDoc){
      this.appService.preLoadDocumento(true);
      this.appService.definirTipoDoc(tipoDoc)
      this.dispatchGtm(tipoDoc);
      this.$router.push({name:'NewDocDigitalizacao'});
    },
    dispatchGtm:function (tipoDoc){
      var lb = 'none';
      switch (tipoDoc){
        case this.docs.cnh:
        case this.docs.cnhdigital:
          lb = 'DriversLicense';
          break;
        case this.docs.rg:
          lb = 'IdCard';
          break;
        case this.docs.outro:
          lb = 'OtherDocuments';
          break;
      }
      DispatchTags.dispatchInraction('DocSelecao' + lb);
    },
    docCnhDigital:function (){
      DispatchTags.dispatchInraction('DocSelecaoCnhDigital');
      this.$router.push({name:'DocCnhDigital'});
      // alert('Desenvolvimento será realizado na demanda VGN-1450');
    }
  }
}
</script>

<style scoped>
#doc-selecao{
  margin-top: 80px;
}
.documentos{
  margin-top: 2rem;
}
.documentos li p{
  margin: 0;
}
.documentos ul li{
  border: 0;
  border-bottom: 1px solid #eee;
  padding: 0.1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  cursor: pointer;
  background-color: transparent;
}
.documentos ul li:hover{
  background: rgb(255,255,255);
  background: linear-gradient(86deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 35%, rgba(238,238,238,1) 100%);
}
.documentos ul li:last-child{
  border-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/DocSelecao.vue